/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Evidence_TitleInputs */

const en_directory_detail_evidence_title = /** @type {(inputs: Directory_Detail_Evidence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence check`)
};

const zh_directory_detail_evidence_title = /** @type {(inputs: Directory_Detail_Evidence_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`证据核查`)
};

/**
* | output |
* | --- |
* | "Evidence check" |
*
* @param {Directory_Detail_Evidence_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_evidence_title = /** @type {((inputs?: Directory_Detail_Evidence_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Evidence_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_evidence_title(inputs)
	return zh_directory_detail_evidence_title(inputs)
});
export { directory_detail_evidence_title as "directory.detail.evidence_title" }